import ZigMenu from '../../../../display/ZigMenu/index.js';
import React__default, { useMemo, useState } from 'react';
import { LayoutItem } from './styles.js';
import { ReactComponent as SvgSettingsIcon } from '../../../../../assets/icons/settings-icon.svg.js';
import { DropdownResetButton } from '../atoms/DropdownResetButton/index.js';
import { isEqual } from 'lodash-es';
import { FiltersCount } from '../atoms/FilterCount/index.js';
import { FilterDropdownWrapper } from '../../styles.js';
import { Box } from '@mui/material';
import ZigButton from '../../../../inputs/ZigButton/index.js';
import MobileFilterDrawer from '../atoms/MobileFilterDrawer/index.js';
import Filter from '../../filters/Filter/index.js';
import { useWindowSize, useRendersCount } from 'react-use';

var MultiFiltersButton = function (_a) {
    var resetFilters = _a.resetFilters, filters = _a.filters, defaultFilters = _a.defaultFilters, onChange = _a.onChange, _b = _a.minSpace, minSpace = _b === void 0 ? 90 : _b, _c = _a.mobile, mobile = _c === void 0 ? false : _c, prefixId = _a.prefixId;
    var filtersChangedCount = useMemo(function () {
        return filters.filter(function (filter) {
            var defaultFilter = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.find(function (defaultFilter) { return defaultFilter.id === filter.id; });
            return !isEqual(filter.value, defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.value);
        }).length;
    }, [filters, defaultFilters]);
    var _d = useState(false), drawerOpen = _d[0], setDrawerOpen = _d[1];
    var height = useWindowSize().height;
    var renders = useRendersCount();
    var hasScrollbar = height < document.body.scrollHeight;
    if (mobile) {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(MobileFilterDrawer, { filters: filters, onChange: onChange, open: drawerOpen, onClose: function () { return setDrawerOpen(false); }, resetFilters: resetFilters, prefixId: prefixId }),
            React__default.createElement(ZigButton, { id: "".concat(prefixId, "__multi-dropdown-mobile"), variant: "outlined", sx: {
                    py: "5px",
                    px: filtersChangedCount > 0 ? "10px" : "12px",
                    minWidth: 0,
                    mr: hasScrollbar || renders <= 1 ? "13px" : 0,
                }, onClick: function () {
                    setDrawerOpen(true);
                } },
                React__default.createElement(Box, { display: "flex", gap: "6px", alignItems: "center" },
                    React__default.createElement(SvgSettingsIcon, { width: 19, height: 16 }),
                    filtersChangedCount > 0 && React__default.createElement(FiltersCount, null, filtersChangedCount)))));
    }
    return (React__default.createElement(FilterDropdownWrapper, null,
        React__default.createElement(ZigMenu, { id: "".concat(prefixId, "__multi-dropdown"), component: function (_a) {
                var open = _a.open;
                return (React__default.createElement(LayoutItem, { active: open, minWidth: minSpace },
                    React__default.createElement(SvgSettingsIcon, { width: 22.5, height: 19 }),
                    filtersChangedCount > 0 && React__default.createElement(FiltersCount, null, filtersChangedCount)));
            }, options: filters
                .flatMap(function (filter) { return [
                {
                    element: (React__default.createElement(Filter, { filter: filter, onChange: onChange, mobile: false, key: filter.id })),
                },
                { separator: true },
            ]; })
                .concat([
                {
                    element: (React__default.createElement(DropdownResetButton, { id: "".concat(prefixId, "__multi-dropdown-reset"), onClick: resetFilters })),
                },
            ]) })));
};

export { MultiFiltersButton as default };
